<!-- <template>
  <div>
    <div>
      <v-autocomplete
        :items="countrycode"
        item-title="name"
        variant="outlined"
        width="auto"
        label="Country Code"
        v-model="receivedShippingId"
      >
      </v-autocomplete>
    </div>
  </div>



</template>

<script>
import country1 from "@/coundtrycode.json";
export default {
  data() {
    return {
      receivedShippingId: "",
      countrycode: [],
    };
  },
  mounted() {
    country1.forEach((v) => {
      let obj = {
        name: `${v.dial_code} ${v.name}`,
        code: v.dial_code,
      };
      this.countrycode.push(obj);
      console.log(this.countrycode, "this.countrycode");
    });
  },
};
</script>

<style>
/* Add any necessary styles here */
</style> -->
<template>
  <div style="background-color: #efeeee !important" class="pageContainer">
    <v-container style="max-width: 900px !important">

 <!-- <div class="text-end" v-if="perlogin">
  <v-menu open-on-hover offset-y>
    <template v-slot:activator="{ props }">
      <v-avatar
        v-bind="props"
        style="cursor: pointer;"
        color="primary"
        size="50"
      >
        <span class="white--text text-h5">{{loginDetails.username.charAt(0)}}</span>
      </v-avatar>
    </template>

    <v-card>
      <v-card-text>
        <h6> {{loginDetails.username}}</h6>
        <h6>{{loginDetails.email}}</h6>
      </v-card-text>
    </v-card>
  </v-menu>
</div> -->




      <!-- quote response -->

      <div class="mt-5
      " v-if="shipmetData">
        <v-card class="p-4" rounded="3">
          <div class="d-flex flex-wrap justify-space-between">
            <div>
               <h6 style="font-size: 18px; font-weight: 700">Your Shipment</h6>
            </div>
           
 <div>
                   <a
                href="#"
                style="text-decoration: underline !important;cursor: pointer;color: navy;"
              @click="(quoteform = true), (shipmetData = false) ,popupTopDetails=false"
              >EDIT</a
            >
                </div>
          </div>

          <div>
            <div class="row">
              <div class="ship">
                <span class="ship-title">From:</span>

                <span class="ship-subtitle">
                  {{ this.formTotalData.fromPostal }},</span
                >

                {{ this.formTotalData.fromCountry }}
              </div>
            </div>
            <div class="row">
              <div class="ship">
                <span class="ship-title"> To:</span>
                <span class="ship-subtitle">
                  {{ this.formTotalData.toPostal }},
                  {{ this.formTotalData.toCountry }}</span
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="ship">
                <span class="ship-title">Shipment Date:</span>
                <span class="ship-subtitle">
                  {{ dataChange(this.formTotalData.shipDate) }}
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="ship">
                <span class="ship-title">Item Type: </span>
                <span class="ship-subtitle">
                  {{ this.formTotalData.itemtype }}</span
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div>
              <div
                class="ship "
                v-for="data of this.formTotalData.items"
                :key="data"
              >

               <div class="row">
                <div class="col-md-8">
                  <span class="ship-title">Package List and Dimensions:</span>
                  <span class="ship-subtitle">
                    {{ data.weight }} KG / {{ data.length }}cm  x
                    {{ data.height }}cm x {{ data.width }}cm x
                    {{ data.quantity }} Box
                  </span>
                </div>

            <div class="col-md-4">
               <span class="ship-title">Chargeable Weight :</span>
                  <span class="ship-subtitle">
                    {{ convertWeight(data) }} Kg
                  </span>
            </div>

               </div>
             


                
               
              </div>
            </div>
          </div>
        </v-card>
      </div>

      <!-- -----------form start----------------------------- -->

      <div v-if="quoteform" style="display: flex;
    justify-content: center;">
        <div class="form-quate"
            >
        <requestFormSmall @updateQuote="handleUpdateQuote" :formData="formTotalData" />
        </div>



      </div>

      <!-- -------------------------------form end--------------------------- -->


<div class="mt-3" v-if="userDetails && popupName">

  <v-card class="p-3" rounded="3">
  
     <div class="d-flex flex-wrap justify-space-between">
            <div>
                 <h5 style="font-size: 18px; font-weight: 700;">User Details</h5>
            </div>
           
 <div @click="userDetails=false, userDetailsBtn=false,popupform=true">
                   <a
                href="#"
                style="text-decoration: underline !important;cursor: pointer;color: navy;"
              >EDIT</a
            >
                </div>
          </div>
    <div>
      <div class="d-flex flex-wrap pb-1 gap-1">
       <div class="ship-title">
         Name:
       </div>


       <div class="ship-subtitle">{{popupName}}</div>
      </div>
<div class="d-flex flex-wrap pb-1 gap-1">
       <div class="ship-title">
        Email:
       </div>
       <div class="ship-subtitle">{{ popupEmail }}</div>
      </div>

      <div class="d-flex flex-wrap pb-1 gap-1">
       <div class="ship-title">
        Phonenumber:
       </div>
       <div class="ship-subtitle">{{popupContact}}</div>
      </div>

    </div>

  </v-card>
</div>



      <div v-if="openOverlay" class=" mt-3">
        <div class="overlay-content">
          <v-card rounded="2" v-if="popupTopDetails">
            
            <div class="p-3 row">
              <div class="d-flex justify-content-center w-100 mb-2">
                Please Login or continue as Guest to fetch the shipment quote.
              </div>
              <div class="col-sm-5">
                <VBtn block class="but-color"
                @click="(loginform = true), (popupTopDetails = false)"
                >
                  <VIcon icon="tabler-user"  />
                  LOGIN
                </VBtn>
              </div>

              <div class="col-sm-2">
                <p class="popupOr m-0">OR</p>
              </div>

              <div class="col-sm-5">
                <VBtn
                  block
                  class="but-color"
                  @click="(popupform = true), (popupTopDetails = false)"
                >
                  CONTINUE AS GUEST
                </VBtn>
              </div>
            </div>
          </v-card>



 <VForm class="mb-5" @submit.prevent="loginForm" v-if="loginform">
            <div class="d-flex justify-center align-center">
              <VCard class="popupform" style="width: 100% !important">
                <div class="d-flex flex-wrap justify-content-between">
                <div>
                  <v-btn @click="loginform=false,popupTopDetails=true,goLoader=false" 
                  color="#1f1f45">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </div>
<div>
        <v-btn  class="but-color" @click="loginform=false,registerform=true,goLoader=false">
        register</v-btn>
        </div>

                </div>
                <div class="popupform_row row mt-2 align-items-center">
                  
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Email</label>

                    <v-text-field
                      class="login-form551"
                      v-model="loginDetails.email"
                      required
                      :rules="[requiredValidator, emailValidator]"
                      prepend-inner-icon="mdi-email"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Password</label>

                  <v-text-field
  v-model="loginDetails.password"
  class="login-form551"
  :type="showPassword ? 'text' : 'password'"
  required
  :rules="[
    v => !!v || 'Password is required'
  ]"
  :prepend-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
  @click:prepend-inner="showPassword = !showPassword"
  variant="outlined"
/>

                  </div>
                  <div class="col-md-4 px-2 py-1" v-if="loginform">
                      <div>
                        <VBtn
                          width="50%"
                          class="but-color"
                          type="submit"
                          :disabled="!loginformValidation"
                          block
                        >
                          <VProgressCircular
                            color="white"
                            v-if="goLoader"
                            indeterminate
                          />
                          {{ !goLoader ? "Submit" : "" }}
                        </VBtn>
                      </div>
                    </div>

                  <!-- <VCol cols="2" /> -->
                </div>
        

              </VCard>
            </div>
          </VForm>
<VForm class="mb-5" @submit.prevent="registerformData" v-if="registerform">
            <div class="d-flex justify-center align-center">
              <VCard class="popupform" style="width: 100% !important">
                <div >
                  <v-btn @click="registerform=false,popupTopDetails=true,goLoader=false" 
                  color="#1f1f45">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </div>
                <div class="popupform_row row mt-2">
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">UserName</label>

                    <v-text-field
                      class="login-form551"
                      v-model="registerDetails.username"
                      required
                      :rules="overallFormValidation"
                      prepend-inner-icon="mdi-account"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Email</label>

                    <v-text-field
                      class="login-form551"
                      v-model="registerDetails.email"
                      required
                      :rules="[requiredValidator, emailValidator]"
                      prepend-inner-icon="mdi-email"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Password</label>

                  <v-text-field
  v-model="registerDetails.password"
  class="login-form551"
  :type="showPassword ? 'text' : 'password'"
  required
  :rules="[
    v => !!v || 'Password is required',
  ]"
  :prepend-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
  @click:prepend-inner="showPassword = !showPassword"
  variant="outlined"
/>

                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <!-- <input type="checkbox" checked />
                      <label style="font-size: 15px" class="ms-2"
                        >Send me special offers on email or whatsApp.</label
                      > -->
                    </div>

                    <div class="col-md-4" v-if="registerform">
                      <div>
                        <VBtn
                          width="50%"
                          class="but-color"
                          type="submit"
                          :disabled="!registerValidation"
                          block
                        >
                          <VProgressCircular
                            color="white"
                            v-if="goLoader"
                            indeterminate
                          />
                          {{ !goLoader ? "Submit" : "" }}
                        </VBtn>
                      </div>
                    </div>
                  </div>

                  <!-- <VCol cols="2" /> -->
                </div>
              </VCard>
            </div>
          </VForm>

          <VForm class="mb-5" @submit.prevent="popupForm" v-if="popupform">
            <div class="d-flex justify-center align-center">
              <VCard class="popupform" style="width: 100% !important">
                <div v-if="userDetailsBtn">
                  <v-btn @click="popupform=false,popupTopDetails=true" 
                  color="#1f1f45">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </div>
                <div class="popupform_row row mt-2">
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Name</label>

                    <v-text-field
                      class="login-form551"
                      v-model="popupName"
                      required
                      :rules="overallFormValidation"
                      prepend-inner-icon="mdi-account"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Email</label>

                    <v-text-field
                      class="login-form551"
                      v-model="popupEmail"
                      required
                      :rules="[requiredValidator, emailValidator]"
                      prepend-inner-icon="mdi-email"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Contact</label>

                    <v-text-field
                      class="login-form551"
                      v-model="popupContact"
                      required
                      :rules="contactRules"
                      prepend-inner-icon="mdi-cellphone"
                      variant="outlined"
                      length="14"
                    ></v-text-field>
                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <input type="checkbox" checked />
                      <label style="font-size: 15px" class="ms-2"
                        >Send me special offers on email or whatsApp.</label
                      >
                    </div>

                    <div class="col-md-4" v-if="popupform">
                      <div>
                        <VBtn
                          width="50%"
                          class="but-color"
                          type="submit"
                          :disabled="!popupformValidation"
                          block
                        >
                          <VProgressCircular
                            color="white"
                            v-if="goLoader"
                            indeterminate
                          />
                          {{ !goLoader ? "GO" : "" }}
                        </VBtn>
                      </div>
                    </div>
                  </div>

                  <!-- <VCol cols="2" /> -->
                </div>
              </VCard>
            </div>
          </VForm>




        </div>
      </div>

      <div v-if="step4" class="w-100">
        <div class="d-flex flex-column justify-center align-center">
          <div style="font-weight: 500; font-size: 20px" class="mt-5">
            Here are the rates for your shipments: <br />
            {{ shipdate }}
          </div>

          <VDivider style="inline-size: 85%" class="mb-5" />

          <div class="w-100">
            <v-card
              v-for="(response, index) in quoteResponse"
              :key="index"
              class="p-3"
              :class="'QuoteResponse mb-4 p-3' + index"
            >

<div class="row align-items-center">
  <div class="col-md-2">
<img
                      :src="response.CarrierLogo"
                      style="height: 60px;"
                     
                    />
  </div>
  <div class="col-md-3" style="    font-size: 14px;
    font-weight: 500;">
    {{ response.CarrierName }} - {{ response.ServiceName }}
  </div>
  
  <div class="col-md-3">
    <div  style="font-size:14px;
    font-weight: 500;">
      <v-icon size="15" color="#ed1c24">mdi-truck-delivery-outline</v-icon>
      <span class="ms-1">Delivery</span>
      <span class="ms-2">{{   momentfuncArrivalDt(response.DeliveryDate.split("T")[0]) }}</span>
      
    </div>
    
  </div>
  
  <div class="col-md-2 d-flex">
    <div  style="color:#1f1f45 ;font-size:18px;
    font-weight: 500;
;"
                  >
                    {{ currency }} {{ response.FreightRate }}

  </div>
  </div>
  <div class="col-md-2">
    <VBtn
                  style="margin-top: 10px;"
                    block
                    color="#ed1c24"
                    class="booknowBtn"
                    @click="
                     
                        delivared(response, index)
                    "
                  >
                   
                    BOOK NOW
                  </VBtn>
  </div>

</div>


            </v-card>
          </div>

          <div class="mt-4 w-100">
            <h5>Are you expecting a better rate?</h5>

            <p>
              Please share your target rate. Our quote tesk will getback to you
              special spot rate.
            </p>

            <div class="row mt-2">
              <div class="col-md-4">
                <label>CARRIER</label>
                <v-select
                  v-model="carrierquote"
                  :items="['DHL', 'FedEx', 'Aramex', 'UPS', 'Others']"
                  variant="outlined"
                ></v-select>
              </div>
              <div class="col-md-4">
                <label>TARGET QUOTE</label>
                <v-text-field
                  variant="outlined"
                  v-model="targequote"
                  :rules="targequoterule"
                  :maxlength="5"
                ></v-text-field>
              </div>
              <div class="col-md-4 mt-5">
                <v-btn
                  class="but-color"
                  style="width: 100%; height: 50px"
                  @click="getquoteData()"
                >
                  <VProgressCircular
                    color="white"
                    v-if="goLoader1"
                    indeterminate
                  />
                  Get Quote</v-btn
                >
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="quoteResponse['is_sucessful'] == false && quoteResponsedisp"
          class="d-flex justify-center align-center"
        >
          <h5>Sorry, No Rate form For This Destination</h5>
        </div>
      </div>

      <!-- booking overlay form -->

      <div class="overlay bg-white pt-3 pb-4 ps-5 pe-5" v-if="bookingOverlay && step5">
        <div class="overlay-content-booking">
          <div class="demo-space-y" />
          <div>
            <div v-if="bookingoverlayStep1">
              <v-form ref="form" v-model="valied1" @submit="shippingDetail">
                <div class="shipperDetail">
                  <VCol cols="12" md="12" sm="12">
                    <div class="d-flex align-center">
                      <div>
                        <VBtn
                          color="#1F1F45"
                          block
                          style="border-radius: 50%; width: 40px; height: 40px"
                        >
                          <b>1</b>
                        </VBtn>
                      </div>

                      <div style="margin-inline-start: 10px">
                        <div class="label-head">SHIPPER DETAILS</div>
                        <p class="label-sub m-0">Setup Shipper Details</p>
                      </div>
                    </div>
                  </VCol>
                  <VCol cols="12" style="margin-block-start: -20px">
                    <VDivider />
                  </VCol>

                  <div class="row">
                    <div class="col-md-4">
                      <label>NAME</label>

                      <v-text-field
                        class="login-form551"
                        v-model="Sendername"
                        required
                        :rules="overallFormValidation"
                        variant="outlined"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4 textfield">
                      <label class="label-title">Country Code</label>
                      <div>
                        <v-autocomplete
                          :items="countrycode"
                          class="login-form551"
                          item-title="name"
                          variant="outlined"
                          width="auto"
                          v-model="senderDialCode"
                          :rules="overallFormValidation"
                        >
                        </v-autocomplete>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">MOBILE</label>

                      <v-text-field
                        class="login-form551"
                        v-model="Sendermobile"
                        required
                        :rules="overallFormValidation"
                        variant="outlined"
                        length="14"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 1</label>

                      <v-text-field
                        class="login-form551"
                        v-model="Senderaddress1"
                        required
                        :rules="overallFormValidation"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 2 </label>
                      <v-text-field
                        class="login-form551"
                        v-model="Senderaddress2"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 3 </label>
                      <v-text-field
                        class="login-form551"
                        v-model="Senderaddress3"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">COMPANY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Sendercompany"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">CITY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Sendercity"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">POSTAL CODE/ LOCATION</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Senderzipcode"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4 textfield">
                      <label class="label-title">EMAIL</label>

                      <v-text-field
                        class="login-form551"
                        v-model="Senderemail"
                        required
                        :rules="overallFormValidation"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row w-100">
                    <div class="col-6">
                      <VBtn
                        color="#1F1f45"
                        width="200px"
                        @click="
                          (bookingoverlayStep1 = false),
                            (this.step4 = true),
                          this.shipmetData = true,
                          this.userDetails=true
                        "
                      >
                        BACK
                      </VBtn>
                    </div>
                    <div
                      class="col-6"
                      style="display: flex; justify-content: end"
                    >
                      <VBtn color="#1F1F45" type="submit" width="200px">
                        NEXT
                      </VBtn>
                    </div>
                  </div>
                </div>
              </v-form>
            </div>

            <div v-if="bookingoverlayStep2">
              <v-form ref="form" v-model="valied2" @submit="shippingDetail2">
                <div class="shipperDetail">
                  <VCol cols="12" md="12" sm="12">
                    <div class="d-flex align-center">
                      <div>
                        <VBtn
                          color="#1F1F45"
                          block
                          style="border-radius: 50%; width: 30px; height: 30px"
                        >
                          <b>2</b>
                        </VBtn>
                      </div>

                      <div style="margin-inline-start: 10px">
                        <div class="label-head">CONSIGNEE DETAILS</div>
                        <p class="label-sub m-0">Setup Consignee Details</p>
                      </div>
                    </div>
                  </VCol>
                  <VCol cols="12" style="margin-block-start: -20px">
                    <VDivider />
                  </VCol>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">NAME</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receivername"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4 textfield">
                      <label class="label-title">Country Code</label>
                      <div>
                        <v-autocomplete
                          :items="countrycode"
                          :rules="overallFormValidation"
                          class="login-form551"
                          item-title="name"
                          variant="outlined"
                          width="auto"
                          v-model="receverDialCode"
                        >
                        </v-autocomplete>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">MOBILE</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receivermobile"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                        length="14"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 1</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receiveraddress1"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 2</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receiveraddress2"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 3</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receiveraddress3"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">COMPANY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receivercompany"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">CITY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receivercity"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">POSTAL CODE/ LOCATION</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receiverzipcode"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">EMAIL</label>
                      <v-text-field
                        class="login-form551"
                        v-model="Receiveremail"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row w-100">
                    <div class="col-6">
                      <VBtn
                        color="#1F1f45"
                        width="200px"
                        @click="
                          (bookingoverlayStep1 = true),
                            (bookingoverlayStep2 = false)
                        "
                      >
                        BACK
                      </VBtn>
                    </div>
                    <div
                      class="col-6"
                      style="display: flex; justify-content: end"
                    >
                      <VBtn color="#1F1F45" width="200px" type="submit">
                        NEXT
                      </VBtn>
                    </div>
                  </div>
                </div>
              </v-form>
            </div>

            <div v-if="bookingoverlayStep3">
              <VRow>
                <VCol cols="12" md="12" sm="12">
                  <div class="d-flex align-center">
                    <div>
                      <VBtn
                        color="#1F1F45"
                        block
                        style="border-radius: 50%; width: 30px; height: 30px"
                      >
                        <b>3</b>
                      </VBtn>
                    </div>

                    <div style="margin-inline-start: 10px">
                      <div class="label-head">SHIPMENT DETAILS</div>
                      <p class="label-sub m-0">Setup Shipment Details</p>
                    </div>
                  </div>
                </VCol>
                <VCol cols="12" style="margin-block-start: -20px">
                  <VDivider />
                </VCol>
                <div class="row w-100">
                  <div class="col-md-6">
                    <label class="label-title">ESTIMATED PICKUP DATE</label>
                    <VueDatePicker
                      v-model="bookingPickupdate"
                      :min-date="new Date()"
                      auto-apply
                      placeholder="Select Date"
                      :on-click-outside="ClickOutDepat"
                      :month-change-on-scroll="false"
                      :enable-time-picker="false"
                    >
                    </VueDatePicker>
                  </div>
                  <div class="col-md-6">
                    <label class="label-title">ENTER CONTENT DESCRIPTION</label>
                    <v-text-field
                      class="login-form551"
                      v-model="bookingcontentDescription"
                      variant="outlined"
                      required
                    ></v-text-field>
                  </div>
                </div>

                <VCol cols="5" md="5" sm="5" />
                <VCol md="3" lg="3">
                  <VBtn
                    color="#1F1F45"
                    block
                    width="200px"
                    @click="
                      (bookingoverlayStep2 = true),
                        (bookingoverlayStep3 = false)
                    "
                  >
                    BACK
                  </VBtn>
                </VCol>
                <VCol md="3" lg="3">
                  <VBtn color="#1F1F45" block type="submit" @click="getEmail()">
                    <VProgressCircular
                      v-if="loader4"
                      color="white"
                      indeterminate
                    />
                    PROCEED
                  </VBtn>
                </VCol>
                <!-- <VCol v-if="sendMailLoader == true" cols="1">
                  <VProgressCircular color="#22224d" indeterminate />
                </VCol> -->
              </VRow>
            </div>
          </div>

          <!-- <VBtn
            class="overlayCloseBtn text-light"
            @click="
              (step4 = true),
                (step5 = true),
                (bookingOverlay = false),
                (popupform = true)
            "
          >
            Back
          </VBtn> -->
        </div>
      </div>
      <v-dialog v-model="step6" persistent>
        <div class="p-5 text-center bg-white m-auto" v-if="step6">
          <div style="font-size: 17px; font-weight: 500">
            Reference ID:
            {{ bookingRefId || this.$route.query.quoteRequest_id }}
          </div>
          <h3>Thank you for your request.</h3>
          <h5>Our representative will contact with you soon.</h5>
          <div class="row mt-4">
            <div class="col-6">
              <v-btn @click="step6 = false" class="but-color"> Back </v-btn>
            </div>
            <div class="col-6">
              <v-btn class="but-color" @click="$router.push('/')"> Get Quote </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>

      <VDialog v-model="finalAlert" width="40%">
        <VCard
          text="Booked Successfully."
          class="finalAlertbox"
          color="primary"
        >
          <template #actions>
            <VBtn
              class="ms-auto"
              style="color: white !important"
              variant="plain"
              @click="sendMailAlertFunc"
            >
              OK
            </VBtn>
          </template>
        </VCard>
      </VDialog>

      <!-- <div class="p-3 text-center bg-white" v-if="targertotal">
        <h3>Thank you contacting Skyroute Express.</h3>
        <h5>Our Quote Desk representative will get in touch with you soon.</h5>
      </div> -->

      <v-dialog v-model="targertotal" persistent>
        <div class="p-5 text-center bg-white m-auto" v-if="targertotal">
          <div style="font-size: 23px; font-weight: 500">
            Reference ID: {{ bookingRefId }}
          </div>
          <h3>Thank you for your request.</h3>
          <h5>Our representative will contact with you soon.</h5>
          <div class="row mt-4">
            <div class="col-6">
              <v-btn @click="targetsource()" class="but-color"> Back </v-btn>
            </div>
            <div class="col-6">
              <v-btn class="but-color" @click="$router.push('/')"> get Quote </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>

      <!-- popup login overlay form -->
    </v-container>

    <v-dialog v-model="Destination" max-width="500">
      <v-card class="p-3 text-center">
        <p style="font-size: 20px; font-weight: 500">
          Sorry, No Rate form For This Destination.
        </p>
        <v-btn
          @click="$router.push('/')"
          class="but-color"
          style="max-width: fit-content; margin: auto"
          >Back to home</v-btn
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import countryList from "@/countries.json";
import requestFormSmall from "@/components/requestFormSmall.vue";
import moment from "moment";
import axios from "axios";
import VueDatePicker from "@vuepic/vue-datepicker";
import country1 from "@/coundtrycode.json";
export default {
  components: {
    VueDatePicker,
    requestFormSmall
  },
  data() {
    return {
      packageRow: [
        {
          quantity: 1,
          weight: "",
          length: "",
          width: "",
          height: "",
        },
      ],
      shipId: "",
      countrycode: [],
      quoteSelected: {},
      quoteselectedId: "",
      QuoteData: "",
      loader4: false,
      shingData: [],
      Destination: false,
      userDetails:false,
        userDetailsBtn:true,
      step1: true,
      step: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
      quoteform: false,
      bookingRefId: "",
      selectedPackage: "BOX",
      selectedFromcountry: null,
      PickupResiQuote: "COMMERCIAL",
      DeliveryResiQuote: "COMMERCIAL",
      DeliveryResiQuote1: "COMMERCIAL1",
      selectedPickupQuote: "PICKUP",
      selectedDeliveryQuote: "DELIVERY",
      selectedDeliveryQuote1: "DELIVERY1",
      selectedPickupQuote1: "PICKUP1",
      selectedTocountry: null,
      fromPostalcode: "",
      toPostalcode: "",
      fromCity: "",
      toCity: "",
      postalsplittedFrom: "",
      formTotalData: [],
      postalsplittedTo: "",
      fromPostalcodeList: [],
      toPostalcodeList: [],
      pickupHub: "DELIVERY AT HUB",
      deliveryHub: " DOOR DELIVERY",
      pickupResi: "COMMERCIAL",
      deliveryResi: "COMMERCIAL",
      measurement: "cm",
      unit: "KG",
      totPackages: 0,
      totWeight: 0,
      currency: "AED",
      shipdateQuote: "",
      // shipdatelist: [],
      shipdate: "",
      carrierquote: "",
      targequote: "",
      quoteId: "",
      quoteResponse: [],
      selectedQuoteResponseId: "",
      selectedQuoteResponseData: "",
      shipmetData: true,
      countryListarray: [],
      fromcountryCode: [],
      tocountryCode: [],
      dateFormat: "dd MMM, yyyy",
      fromPostalUl: false,
      toPostalUl: false,
    fromCuCode:"",
    toCuCode:"",

      openOverlay: false,
      popupform: false,
      popupTopDetails: true,
      finalAlert: false,
      loginform:false,
      registerform:false,
      //carrierLogo
      carrierLogoPrefix: "https://about:blank",

      // rules

      lastrowValidation: [
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9]*$/.test(v) || "Only numeric values are allowed",
      ],
      overallFormValidation: [(v) => !!v || "Please enter a valid input"],
      // emailRequire: [
      //   v => !!  "Please enter a valid input",
      //   v => /.+@.+\..+/.test(v) || "Please enter a valid email address",
      // ],
      targequoterule: [
        (v) => /^[0-9+ -]*$/.test(v) || "Only numeric values are allowed",
        // (value) => {
        //   if (value?.length === 5) return true;
        //   return "Contact number must be 5 characters long.";
        // },
        (v) => !!v || "Please enter a valid input",
      ],
      contactRules: [
        (value) => {
          if (value?.length >= 5) return true;
          return "Enter a valid number.";
        },
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9+\-\s]*$/.test(v) || "Only numbers, +, - and spaces are allowed",
      ],
      //quoterequest hide and show variables
      // allItemsQuote: [
      //   {
      //     selectedPackageQuote: "BOX",
      //     weightQuote: "",
      //     quantityQuote: "",
      //     heightQuote: "",
      //     widthQuote: "",
      //     lengthQuote: "",
      //   },
      // ],
      countryPostalcontFrom: false,
      countryPostalcontTo: false,
      pickupDelblock: false,
      pickupDelblockBtn: true,
      shipmentblock: false,
      shipmentblockBtn: false,
postalFrom:false,
       postalTo:false,
       dupFromData:[],
dupToData:[],
      //loaders
      responseLoader: false,
      sendMailLoader: false,

      goLoader: false,
      goLoader1: false,
      // popupdata
      popupName: "",
      popupEmail: "",
      popupContact: "",
      perlogin:false,
      loginDetails:{
username:"admin",
email:"",
password:""
      },
       registerDetails:{
username:"",
email:"",
password:""
      },

showPassword:false,
      quoteResponsedisp: false,
       endpoint:"",
      //bookingoverlay
      bookingOverlay: false,
      bookingoverlayStep1: true,
      bookingoverlayStep2: false,
      bookingoverlayStep3: false,
      targertotal: false,
      // bookingform data
      valied1: false,
      valied2: false,
      valied3: false,
      Sendername: "",
      Receivername: "",
      Senderemail: "",
      Receiveremail: "",
      Sendercompany: "",
      Receivercompany: "",
      Sendermobile: "",
      Receivermobile: "",
      Senderaddress1: "",
      Receiveraddress1: "",
      Senderaddress2: "",
      Receiveraddress2: "",
      Senderaddress3: "",
      Receiveraddress3: "",
      Sendercity: "",
      Receivercity: "",
      Senderzipcode: "",
      Receiverzipcode: "",
      bookingcontentDescription: "",
      bookingPickupdate: "",
      senderDialCode: "",
      receverDialCode: "",
    };
  },
  computed: {
    filteredCountryNames() {
      console.log(countryList,'countryList')
      countryList.forEach((item) => {
        return this.countryListarray.push({
          code: item.code,
          country: item.name,
        });
      });

      return countryList.map((country) => country.name);
    },

    // shipdates(){
    //   let currentDate = new Date()
    //   let date = currentDate.getDate()
    //   date = date < 10 ? '0' + date : date
    //   let month = currentDate.getMonth() + 1
    //   month = month < 10 ? '0' + month : month
    //   let year = currentDate.getFullYear()

    //   let firstday = `${year}-${month}-${date}`

    //   let originalDate = new Date(firstday)
    //   let onedayLater = new Date(originalDate)
    //   onedayLater.setDate(originalDate.getDate()+1)
    //   let date2 = onedayLater.getDate()
    //   date2 = date2 < 10 ? '0' + date2 : date2
    //   let month2 = onedayLater.getMonth() + 1
    //   month2 = month2 < 10 ? '0' + month2 : month2
    //   let year2 = onedayLater.getFullYear()

    //   let secondday = `${year2}-${month2}-${date2}`

    //   this.shipdatelist=[]
    //   this.shipdatelist.push(firstday, secondday)

    //   this.shipdatelist = this.momentfunc(this.shipdatelist)

    //   return this.shipdatelist
    // },



    formValidation() {
      return (
        this.selectedFromcountry !== "" &&
        this.selectedTocountry !== "" &&
        this.totPackages !== "" &&
        this.totWeight !== "" &&
        this.shipdate !== "" &&
        this.packageRow.every(
          (item) =>
            item.weight !== "" &&
            item.quantity !== "" &&
            item.height !== "" &&
            item.length !== "" &&
            item.width !== ""
        )
      );
    },
    booknowValidation() {
      return (
        this.Senderaddress1 !== "" &&
        this.Senderaddress2 !== "" &&
        this.Receivername !== "" &&
        this.Receiveremail !== "" &&
        this.validateEmail(this.Receiveremail) &&
        this.Receivermobile !== "" &&
        this.Receivermobile.length >= 5 &&
        this.validateContact(this.Receivermobile) &&
        this.Receiveraddress1 !== "" &&
        this.Receiveraddress2 !== "" &&
        this.bookingcontentDescription !== "" &&
        this.checkCompanySender(this.pickupResi) &&
        this.checkCompanyReceiver(this.deliveryResi)
      );
    },
    popupformValidation() {
      return (
        this.popupName !== "" &&
        this.popupEmail !== "" &&
        this.validateEmail(this.popupEmail) &&
        this.popupContact !== "" &&
        this.validateContact(this.popupContact)
      );
    },
    loginformValidation() {
      return (
        this.loginDetails.password !== "" &&
        this.loginDetails.username !== "" &&
          this.validateEmail(this.loginDetails.email) &&
        this.loginDetails.email !== ""
      );
    },
    registerValidation() {
      return (
        this.registerDetails.password !== "" &&
        this.registerDetails.username !== "" &&
         this.validateEmail(this.registerDetails.email) &&
        this.registerDetails.email !== ""
      );
    },
  },
  

  methods: {

  handleUpdateQuote(value) {
      console.log('Received from child:', value); 
      if(value){
         window.location.reload();
      }
    },

  convertWeight(data) {
    console.log(data ,'ioii')
  const volumetric = ((data?.length * data?.width * data?.height) / 4000) * data.quantity;
  const weight=data?.weight * data.quantity
  return volumetric < weight ? Math.ceil(weight)  : Math.ceil(volumetric) ;
},


   

    changeurl() {
      window.open(`https://skyrouteexpress.com`, "_blank");
    }, dataChange($event) {
      // console.log()
      return moment($event).format("DD-MMM-YYYY");
    },
    shippingDetail() {
      console.log(this.valied1, "valied1");
      if (this.valied1) {
        (this.bookingoverlayStep1 = false), (this.bookingoverlayStep2 = true);
      }
    },
    shippingDetail2() {
      console.log(this.valied1, "valied1");
      if (this.valied2) {
        (this.bookingoverlayStep2 = false), (this.bookingoverlayStep3 = true);
      }
    },

    validateEmail(email) {
      return /.+@.+\..+/.test(email);
    },
    validateContact(contact) {
      return /^[0-9+ -]*$/.test(contact);
    },
    checkCompanySender(companysender) {
      if (
        (companysender == "COMMERCIAL" && this.Sendercompany !== "") ||
        (companysender == "RESIDENTIAL" &&
          (this.Sendercompany == "" || this.Sendercompany !== ""))
      ) {
        return true;
      }
    },
    checkCompanyReceiver(companyreceiver) {
      if (
        (companyreceiver == "COMMERCIAL" && this.Receivercompany !== "") ||
        (companyreceiver == "RESIDENTIAL" &&
          (this.Receivercompany == "" || this.Receivercompany !== ""))
      ) {
        return true;
      }
    },
    selectedFromPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.fromPostalcode = `${data1}-${data2}`;
      } else {
        this.fromPostalcode = `${data1} - ${data2}`;
      }
      this.fromPostalUl = false;
      this.postalsplittedFrom = this.fromPostalcode.split("-");
      this.fromCity = this.postalsplittedFrom[1];
      this.countryPostalcontFrom = true;
    },
    selectedToPostal(data1, data2) {
      if (data1 == null) {
        data1 = "";
        this.toPostalcode = `${data1}-${data2}`;
      } else {
        this.toPostalcode = `${data1} - ${data2}`;
      }
      this.toPostalUl = false;
      this.postalsplittedTo = this.toPostalcode.split("-");
      this.toCity = this.postalsplittedTo[1];
      this.countryPostalcontTo = true;
    },
    addPackage() {
      this.packageRow.push({
        quantity: "",
        weight: "",
        length: "",
        width: "",
        height: "",
      });
    },
    removePackage(index) {
      this.packageRow.splice(index, 1);
    },
    // calculateTotalWeightAndQuantity() {
    //   this.totPackages = this.packageRow.reduce((total, row) => {
    //     return total + parseInt(row.quantity || 0);
    //   }, 0);

    //   this.totWeight = this.packageRow.reduce((total, row) => {
    //     return total + parseInt(row.weight || 0) * parseInt(row.quantity || 0);
    //   }, 0);
    // },
    momentfuncArrivalDt(date) {
      return moment(date).format("ddd Do");
    },

    // momentfunc(datelist){
    //   return datelist.map(element=>moment(element).format('dddd, MMMM DD, YYYY'))
    // },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = currentDate.getDate();
      day = day < 10 ? "0" + day : day;

      return `${year}-${month}-${day}`;
    },
    postalZipcodefunc() {
      if (
        this.postalsplittedFrom[0] == "" ||
        this.postalsplittedFrom[0] == null
      ) {
        this.Senderzipcode = this.postalsplittedFrom[1];

        return (this.fromPostalcode = this.postalsplittedFrom[1]);
      } else {
        this.Senderzipcode = this.postalsplittedFrom[0];

        return (this.fromPostalcode = this.postalsplittedFrom[0]);
      }
    },
    postalZipcodeTofunc() {
      if (this.postalsplittedTo[0] == "" || this.postalsplittedTo[0] == null) {
        this.Receiverzipcode = this.postalsplittedTo[1];

        return (this.toPostalcode = this.postalsplittedTo[1]);
      } else {
        this.Receiverzipcode = this.postalsplittedTo[0];

        return (this.toPostalcode = this.postalsplittedTo[0]);
      }
    },
    async getQuote() {
      this.goLoader = false;
      this.popupform = true;
      this.postalZipcodefunc();
      this.postalZipcodeTofunc();

      let quoteDetails = {
        fromCountry: this.selectedFromcountry,
        toCountry: this.selectedTocountry,
        fromPostal: this.fromPostalcode,
        toPostal: this.toPostalcode,
        fromcity: this.fromCity,
        tocity: this.toCity,
        fromcountrycode: this.fromcountryCode[0].code,
        tocountrycode: this.tocountryCode[0].code,
        pickup: this.pickupHub,
        delivery: this.deliveryHub,
        pickupresi: this.pickupResi,
        deliveryresi: this.deliveryResi,
        shipDate: this.shipdateTosend,
        packageType: this.selectedPackage,
        unit: this.unit,
        totalQuantity: this.totPackages,
        totalWeight: this.totWeight,
        currency: this.currency,
        quoteId: this.quoteId,
        items: this.packageRow.map((item) => ({
          quantity: item.quantity,
          weight: item.weight,
          height: item.height,
          length: item.length,
          width: item.width,
        })),
      };

      this.quoteId = quoteDetails.quoteId;

      let initialDate = new Date(this.shipdateTosend);
      let twodaysLater = new Date(initialDate);
      twodaysLater.setDate(initialDate.getDate() + 2);
      this.bookingPickupdate = twodaysLater.toISOString().slice(0, 10);

      this.Sendercity = this.fromCity;
      this.Receivercity = this.toCity;
      this.Senderzipcode = this.fromPostalcode;
      this.Receiverzipcode = this.toPostalcode;

      this.openOverlay = true;

      console.log(quoteDetails, "quoteDetailsquoteDetails11");

      try {
        const response = await axios.post(
          `https://xportal.skyrouteexpress.com/api/getquote2`,
          quoteDetails,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // this.openOverlay = false;
        this.responseLoader = false;
        this.quoteResponsedisp = true;
        (this.responseLoader = true), (this.step3 = false), (this.step4 = true);
        this.quoteResponse = response.data.QuoteResponse2["data"];
        console.log(this.quoteResponse, response, "quoteResponse");
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    },

    async getQuote1() {
      let quotedata = this.shingData;

      this.getquoteloader = true;
      console.log(quotedata, "quotedataquotedata");
      try {
        const response = await axios.post(
          `https://xportal.skyrouteexpress.com/api/getquote2`,
          quotedata,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        this.goLoader = false;

        this.getQuoteId = quotedata.getQuoteId;
        console.log(this.getQuoteId, "getquoteid");
        console.log(response, "apiresponseee");
        this.responseLoader = false;
        this.quoteResponsedisp = true;
        (this.responseLoader = true), (this.step3 = false), (this.step4 = true);
        this.quoteResponse = response.data.QuoteResponse2.data._RatesResponce;
        console.log(
          response.data.QuoteResponse2.data._RatesResponce,
          "response.data._RatesResponce"
        );
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    },
    targetsource() {
      this.targertotal = false;
      this.step4 = true;
      this.openOverlay = true;
    },
async loginForm() {
      this.goLoader = true;

        try {
          const response = await axios.post(
            `https://xportal.skyrouteexpress.com/api/registerCustomer`,
            this.loginDetails,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          let $dataResponce=response.data.data

          console.log(response, "responseloginDetails");
          if(response.data.success){
         
          this.popupName=$dataResponce.name
          this.popupEmail=$dataResponce.email
          this.popupContact="954754572474"
          this.popupForm()
          
          
          }
          
        
        } catch (error) {
          console.error("There was a problem with the fetch operation:", error);
        }

    },
async registerformData() {
      this.goLoader = true;

        try {
          const response = await axios.post(
            `https://xportal.skyrouteexpress.com/api/registerCustomer`,
            this.registerDetails,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          let $dataResponce=response.data.data

          console.log(response, "responseloginDetails");
          if(response.data.success){
        
          this.popupName=$dataResponce.name
          this.popupEmail=$dataResponce.email
          this.popupContact="954754572474"
          this.popupForm()
          }
          
        
        } catch (error) {
          console.error("There was a problem with the fetch operation:", error);
        }

    },
    async popupForm() {
      this.goLoader = true;

      if (this.shipId) {

        let passDeatils = {
          Name: this.popupName,
          Email: this.popupEmail,
          Contact: this.popupContact,
          QuoteProcessId: this.shipId,
        };
       this.Sendername= this.popupName
        this.Senderemail= this.popupEmail
        this.Sendermobile=this.popupContact
        console.log(passDeatils, "passDeatils");
        try {
          const response = await axios.post(
            `https://xportal.skyrouteexpress.com/api/cachePopupformdata`,
            passDeatils,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log(response, "responsevvvv");
        window.addEventListener("load", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
          if (response.data.QuoteResponseCache.data._RatesResponce.length > 0) {
          this.perlogin=true
          this.userDetails=true
            this.registerform=false
           this.loginform=false
            this.step4 = true;
            this.popupform=false
            this.goLoader = false;
            console.log(response, "apiresponseee");
            this.responseLoader = false;
            this.quoteResponsedisp = true;
            (this.responseLoader = true),
              (this.step3 = false)
              
            if (
              response.data.QuoteResponseCache.data._RatesResponce[0] ==
              "restricted"
            ) {
              this.step6 = true;
            } else {
              this.quoteResponse =
                response.data.QuoteResponseCache.data._RatesResponce;
            }
          } else {
            this.goLoader = false;
            this.Destination = true;
          }

          console.log(
            response.data.QuoteResponseCache.data._RatesResponce,
            "response.data._RatesResponce"
          );
        } catch (error) {
          console.error("There was a problem with the fetch operation:", error);
        }
      } 
      else {
        this.getQuote();
      }

    
    },
    sendMail(event) {
      this.sendMailLoader = true;
      if (
        this.valied1 &&
        this.valied1 &&
        this.bookingcontentDescription &&
        this.bookingPickupdate
      ) {
        // this.step5 = false;
        this.step6 = true;

        console.log(event, "event");
        let bookingformdata = {
          Sendername: this.Sendername,
          Receivername: this.Receivername,
          Senderemail: this.Senderemail,
          Receiveremail: this.Receiveremail,
          Sendercompany: this.Sendercompany,
          Receivercompany: this.Receivercompany,
          Sendermobile: this.Sendermobile,
          Receivermobile: this.Receivermobile,
          Senderaddress1: this.Senderaddress1,
          Receiveraddress1: this.Receiveraddress1,
          Senderaddress2: this.Senderaddress2,
          Receiveraddress2: this.Receiveraddress2,
          Senderaddress3: this.Senderaddress3,
          Receiveraddress3: this.Receiveraddress3,
          Sendercity: this.Sendercity,
          Receivercity: this.Receivercity,
          Senderzipcode: this.Senderzipcode,
          Receiverzipcode: this.Receiverzipcode,
          bookingPickupdate: moment(this.bookingPickupdate).format(
            "YYYY-MM-DD"
          ),
          bookingcontentDescription: this.bookingcontentDescription,
        };
        this.selectedQuoteResponseData =
          this.quoteResponse["_RatesResponce"][this.selectedQuoteResponseId];

        let booknowData = {
          formId: this.quoteId,
          quoteselected: this.selectedQuoteResponseData,
          quoteselectedId: this.selectedQuoteResponseId,
          quoteSelected: this.selectedQuoteResponseData,
          bookingformdata: bookingformdata,
        };
        console.log(booknowData, "booknowData");
        axios
          .post(
            `https://xportal.skyrouteexpress.com/api/getQuoteMail2`,
            booknowData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.finalAlert = true;
            this.sendMailLoader = false;

            console.log(response, "responseeee");
            return response.data;
          })
          .catch((error) => {
            this.sendMailLoader = false;
            console.error("There was a problem with this operation:", error);
          });
      }
    },
    sendMailAlertFunc() {
      this.finalAlert = false;
      if (!this.finalAlert) {
        window.location.href =
          "https://xportal.skyrouteexpress.com/requestform2";
      }
    },
    shingConvertData() {
      this.shipId = this.$route.query.quoteRequest_id;

      // console.log(this.$route.query.quoteData, window.location, "pppp");
      if (this.shipId) {
        this.step1 = false;
        this.popupTopDetails = true;
        this.openOverlay = true;

        let $data = {
          quoteProcessId: this.shipId,
        };
        axios
          .post(
            `https://xportal.skyrouteexpress.com/api/quoterequestdetails`,
            $data,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.formTotalData = JSON.parse(
              response.data.quoterequestdetails.QuoteRequestData
            );
            console.log(this.formTotalData, "this.formTotalData");
            this.selectedFromcountry = this.formTotalData.fromCountry;
             this.fromCuCode=this.formTotalData.fromcountrycode,
             this.toCuCode=this.formTotalData.tocountrycode,
             console.log(this.fromcountrycode,'this.fromcountrycode')
            this.fromPostalcode = this.formTotalData.fromPostal;
            this.selectedTocountry = this.formTotalData.toCountry;
            this.toPostalcode = this.formTotalData.toPostal;
            this.allItemsQuote = this.formTotalData.items;
           
            this.Senderzipcode = this.formTotalData.fromPostal;
            this.Sendercity = this.formTotalData.fromcity;
            this.Receiverzipcode = this.formTotalData.toPostal;
            this.Receivercity = this.formTotalData.tocity;

          })
          .catch((error) => {
            console.error("There was a problem with this operation:", error);
          });
      }
    },
    delivared(response, index) {
      console.log(response, index, "response, index");
      window.addEventListener("load", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
       this.bookingOverlay= true,
        this.selectedQuoteResponseId = index;
         this.popupform = false;
         this.step4 = false;
         this.step5 = true;
         this.shipmetData = false;
          this.userDetails=false;
          this.bookingoverlayStep1=true;
      this.quoteSelected = response;
      this.quoteselectedId = index;
    },
    async getEmail() {
      this.loader4 = true;
      if (
        this.valied1 &&
        this.valied2 &&
        this.bookingcontentDescription &&
        this.bookingPickupdate
      ) {
        let $getEmail = {
          formId: this.shipId,
          quoteselectedId: this.quoteselectedId,

          quoteSelected: {
            IsCodApplicable: this.quoteSelected.IsCodApplicable,
            TopayCharges: this.quoteSelected.TopayCharges,
            CodCharges: this.quoteSelected.CodCharges,
            ODACharges: this.quoteSelected.ODACharges,
            DocketCharge: this.quoteSelected.DocketCharge,
            FreightRate: this.quoteSelected.FreightRate,
            Weight: this.quoteSelected.Weight,
            CompanyId: this.quoteSelected.CompanyId,
            CarrierName: this.quoteSelected.CarrierName,
            ServiceName: this.quoteSelected.ServiceName,
            ServiceId: this.quoteSelected.ServiceId,
            CarrierId: this.quoteSelected.CarrierId,
            DocType: this.quoteSelected.DocType,
            maxPrice: this.quoteSelected.maxPrice,
            minPrice: this.quoteSelected.minPrice,
            GrandTotal: this.quoteSelected.GrandTotal,
            SubTotal: this.quoteSelected.SubTotal,
            IsError: this.quoteSelected.IsError,
            TaxName1: this.quoteSelected.TaxName1,
            TaxAmount1: this.quoteSelected.TaxAmount1,
            TaxName2: this.quoteSelected.TaxName2,
            TaxAmount2: this.quoteSelected.TaxAmount2,
            TaxName3: this.quoteSelected.TaxName3,
            TaxAmount3: this.quoteSelected.TaxAmount3,
            TaxName4: this.quoteSelected.TaxName4,
            TaxAmount4: this.quoteSelected.TaxAmount4,
            TotalTax: this.quoteSelected.TotalTax,
            OrgLcnId: this.quoteSelected.OrgLcnId,
            DestLcnId: this.quoteSelected.DestLcnId,
            FuelSurcharge: this.quoteSelected.FuelSurcharge,
            Othercharges: this.quoteSelected.Othercharges,
            RateEntryType: this.quoteSelected.RateEntryType,
            CovidCharge: this.quoteSelected.CovidCharge,
            VolumetricWgtDenominator:
              this.quoteSelected.VolumetricWgtDenominator,
            IsSpotRate: this.quoteSelected.IsSpotRate,
            FOVType: this.quoteSelected.FOVType,
            FOVCharge: this.quoteSelected.FOVCharge,
            DeliveryDate: this.quoteSelected.DeliveryDate,
            CarrierLogo: this.quoteSelected.CarrierLogo,
            IsAWBChargesApplicable: this.quoteSelected.IsAWBChargesApplicable,
            ToPayApplicable: this.quoteSelected.ToPayApplicable,
            AWBCharges: this.quoteSelected.AWBCharges,
            no_of_days_to_deliver: this.quoteSelected.no_of_days_to_deliver,
          },

          bookingformdata: {
            Sendername: this.Senderemail,
            Receivername: this.Receivername,
            Senderemail: this.Senderemail,
            Receiveremail: this.Receiveremail,
            Senderdialcode: this.senderDialCode,
            Receiverdialcode: this.receverDialCode,
            Sendercompany: this.Sendercompany,
            Receivercompany: this.Receivercompany,
            Sendermobile: this.Sendermobile,
            Receivermobile: this.Receivermobile,
            Senderaddress1: this.Senderaddress1,
            Receiveraddress1: this.Receiveraddress2,
            Senderaddress2: this.Senderaddress2,
            Receiveraddress2: this.Receiveraddress2,
            Senderaddress3: this.Senderaddress3,
            Receiveraddress3: this.Receiveraddress3,
            Sendercity: this.Sendercity,
            Receivercity: this.Receivercity,
            Senderzipcode: this.Senderzipcode,
            Receiverzipcode: this.Receiverzipcode,
            bookingPickupdate: this.bookingPickupdate,
            bookingcontentDescription: this.bookingcontentDescription,
          },
        };
console.log($getEmail,'$getEmail')
        try {
          const response = await axios.post(
            `https://xportal.skyrouteexpress.com/api/getQuoteMail2`,
            $getEmail,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          setTimeout(() => {
            // this.step5 = false;
            this.loader4 = false;
            this.step6 = true;
          }, 3000);
          this.bookingRefId = response.data.booking_reference_id;
          console.log(response, "responseresponse333$getEmail");
        } catch (e) {
          console.log(e, "iioioioi");
        }

        // console.log($getEmail, "$getEmail ");
      }
    },
  },
  created() {

this.endpoint=localStorage.getItem("endpoint")

    this.shingConvertData();
    this.quoteId = Math.ceil(Math.random() * 1000000);
    console.log("Math.ceil(Math.random() * 1000000)", this.quoteId);
  },
  mounted() {
    country1.forEach((v) => {
      let obj = {
        name: `${v.dial_code} ${v.name}`,
        code: v.dial_code,
      };
      this.countrycode.push(obj);
      
    });
   
    setTimeout(()=>{
    
       this.countrycode.forEach((c)=>{
        if(c.name.includes(this.formTotalData.fromCountry)){
          this.senderDialCode=c.name
        }
       })
   console.log(this.countrycode,this.formTotalData.fromCountry, this.senderDialCode,'this.countrycode')
    },2000)
  },
};
</script>


<style scoped>
.pageContainer {
  display: flex;
  justify-content: center;
}

.shipperDetail .v-col-md-4 {
  padding: 0 12px !important;
}

.measureSection .title-sub span {
  color: red;
  position: relative;
  top: -3;
}

/* .overallformcard {
  margin-block: 6.2rem;
} */

.formelements {
  inline-size: 65%;
}

.removeBtn {
  margin-block-start: 23px;
}

.measurementSymbol {
  padding-block-start: 24px;
}

.v-autocomplete__selection-text,
.v-select__selection-text {
  padding-block: 10px;
  padding-inline: 0;
}

.v-autocomplete--single.v-text-field input {
  inset-block-start: 24px;
}

.formelements .v-label {
  font-size: 12px !important;
  font-weight: 1000 !important;
}

.v-table {
  box-shadow: 0 2px 6px rgba(var(--v-shadow-key-umbra-color), 0.14),
    0 0 transparent, 0 0 transparent;
  padding-block: 15px;
  padding-inline: 5px;
}

.v-table th {
  line-height: 1;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
  appearance: none;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
}


.popupOr {
  text-align: center;
}

.popupform {
  padding: 20px !important;
  border-radius: 15px;
  inline-size: 80%;
  margin-block-start: 50px;
}

.popupdetailsdispCard {
  padding: 20px !important;
  inline-size: 65%;
  /* margin-block: 40px 40px; */
}

.fromandto .v-field__input {
  block-size: 60px;
}

.radioMargins {
  margin-block: -20px -20px !important;
}

.dropdowdata {
  position: absolute;
  z-index: 99;
  padding: 5;
  border-radius: 8px;
  margin: 0;
  background-color: white;
  box-shadow: inset 0 0 2px black;
  max-width: 100%;
  list-style: none;
  margin-block-start: 7px;
  overflow-y: scroll;
  height:250px;
      width: 250px;
  cursor: pointer;
}

.dropdowdatali {
  padding: 10px;
  cursor: pointer;
}

.dropdowdatali:hover {
  background-color: #f0f0f0;
}

.popupLabel::after {
  color: #ed1c24;
  content: "*";
  font-size: 17px;
}

.overlayCloseBtn {
  position: absolute;
  background-color: #22224d !important;
  margin-block-start: -40px;
  color: white !important;
}

.booknowBtn {
  padding-block:25px !important;
}

.finalAlertbox {
  padding: 35px;
  background-color: #22224d !important;
  border-inline-start: 5px solid #ed1c24 !important;
  color: white !important;
  inline-size: 100%;
}

.tabler-map-pins {
  font-size: 27px !important;
}
.title-sub {
  font-size: 15px;
  font-weight: 500;
}
.in-design {
  border: 1px solid;
  width: 138px;
  height: 39px;
  border-radius: 5px;
  font-size: 15px;
  padding: 0px 9px;
  margin-top: 3px;
}
>>> .login-form551 .v-field {
  height: 42px !important;
}
>>> .login-form551 .v-field__prepend-inner {
  height: 42px !important;
}
>>> .login-form551 .v-field__field {
  height: 42px !important;
}
>>> .login-form551 .v-field__input {
  padding-top: 0 !important;
}

.label-title {
  font-size: 14px;
  font-weight: 500;
  color: #545353;
  margin-bottom: 3px;
  font-weight: 500;
  line-height: 1.25rem;
  font-family: "Public Sans", sans-serif, -apple-system, blinkmacsystemfont,
    "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol" !important;
  text-transform: none !important;
}
.label-head {
  font-size: 19px;
  font-weight: 600;
  color: #2f2b3de0;
  font-family: "Public Sans", sans-serif, -apple-system, blinkmacsystemfont,
    "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol" !important;
}
.label-sub {
  font-size: 15px;
  font-weight: 500;
  font-family: "Public Sans", sans-serif, -apple-system, blinkmacsystemfont,
    "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol" !important;
}
.but-color {
  background-color: #1f1f45 !important;
  color: white !important;
}
>>> .text-area .v-field__field {
  height: 50px !important;
}
.ship-title {
  font-size: 14px;
  font-weight: 700;
}
.ship-subtitle {
  font-weight: 500;
  font-size: 14px;
  margin-left: 4px;
}
.ship {
  /* border-bottom: 1px solid lightgray; */
  margin-bottom: 3px;
}

/* ----form start------ */
.form-quate {
  background-color: #fff !important;
  box-shadow: 0 0 5px 2px #605e5e;
  /* border: 5px solid #e11c09; */
  width: 650px;
}
>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
        background: none !important;
}
>>>.postal-form .v-field__input {
    top: -2px !important;
}
</style>
